"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ShoppingContextDataEvent = void 0;
/** The name of analytics event with selected shopping context data. */
const ShoppingContextDataEvent = exports.ShoppingContextDataEvent = 'shopping-context-data';

/** Partial shopping session context data to be forwarded into analytics. */
